/* 
.contact_item > span {
    color: black;
    font-weight: 500;
}


.contactInfo_social > a > .MuiSvgIcon-root {
    font-size: 16px;
    margin-right: 10px;
    color: black;
} */

const {makeStyles} = require ('@material-ui/core');

const useStyles = makeStyles (theme => ({
  section: {
    backgroundColor: "#2d3748",
    color: "#808d9f",
    marginBottom: 10
  },
  sectionTitle: {
    position: 'relative',
    padding: '0 3px',
    display: 'inline-block',
    marginBottom: 30
  },
  span: {
    position: 'absolute',
    height: 7,
    width: '100%',
    bottom: 0,
    opacity: 0.2,
    left: 0,
    backgroundColor: '#bdbdbd',
  },
  sectionTitleText: {
    fontSize: 20,
    fontWeight: 600,
    position: 'relative',
    margin: 0,
  },

  /* Contact Section */
  contactItem: {
    fontFamily: "'Roboto Slab', serif",
    fontSize: 16,
    color: '#bdbdbd',
  },
  contactInfoSocialsContainer: {
    marginTop: 20,
    marginLeft: 25,
  },
  contactInfoSocial: {},
  contactInfo: {
    fontFamily: "'Roboto Slab', serif",
    marginTop: 0,
    marginLeft: 10,
  },
  a: {
    
    color: '#808d9f',
    '&:hover': {
      color: '#bdbdbd',
    },
  },
  textField: {
    border: "1px solid #1a202c",
    borderRadius: 5,
    backgroundColor: "#808d9f",
    padding: 10,
    color: '#2d3748'
  },
}));

export default useStyles;
